import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
    public status: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    display(value: boolean) {
        this.status.next(value);
    }

    convertSrtingIntoArrayOfObj(data) {
    const emails = data.split(',').map(email => ({
      email: email.trim()
    }));
    return emails
  }
  
  convertEmailsInString(data) {
    return data.map(x => x.email)
      .filter(Boolean)
      .join(',');
  }
    getRoleName(role: string): string {
    const roles = {
      '1': 'admin',
      '3': 'wms',
      '4': 'normal',
      '5': 'slave_admin',
      '6': 'ze',
      '7': 'dg'
    };

    return roles[role] || 'normal';
  }
}
